import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeHtml',
  standalone: false,
})
export class SanitizeHtmlPipe implements PipeTransform {
  private _sanitizer: DomSanitizer = inject(DomSanitizer);

  transform(v: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(v);
  }
}
